import { render, staticRenderFns } from "./recentLive.vue?vue&type=template&id=2d5d1f0d&scoped=true"
import script from "./recentLive.vue?vue&type=script&lang=js"
export * from "./recentLive.vue?vue&type=script&lang=js"
import style0 from "./recentLive.vue?vue&type=style&index=0&id=2d5d1f0d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5d1f0d",
  null
  
)

export default component.exports